<template>
  <div >
    <HeadNav />
    <AppMain />
    <Footer />
  </div>
</template>

<script>
import HeadNav from './components/HeadNav'
import AppMain from './components/AppMain'
import Footer from './components/Footer'

export default {
  name: 'Layout',
  components: { HeadNav, AppMain, Footer },
}
</script>

<style lang="scss" >

</style>
